import { Component } from 'react'
import { apiFetch } from '../api'
import PropTypes from 'prop-types'

export default class FilteredList extends Component {
  query() {
    const params = this.getSearchParams().reduce(
      (a, k) => {
        if (this.state[k]) {
          a[k] = this.state[k]
        }
        return a
      },
      {
        sort: this.state.sort && this.state.sort.id,
        dir: this.state.sort && this.state.sort.dir,
      }
    )

    return apiFetch(
      `${this.props.searchUrl}?` +
        Object.keys(params)
          .map(k => `${k}=${encodeURIComponent(params[k])}`)
          .join('&')
    )
  }
}

FilteredList.propTypes = {
  searchUrl: PropTypes.string,
}
